import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Expanding.Table", void 0, Table);
}

export function Table_setExpanded(updater, table) {
    table._obj.setExpanded(updater);
    return table;
}

export function Table_toggleAllRowsExpanded_Z4395D14A(table) {
    table._obj.toggleAllRowsExpanded();
    return table;
}

export function Table_resetExpanded(defaultValue, table) {
    table._obj.resetExpanded(defaultValue);
    return table;
}

export function Table_getCanSomeRowsExpand_Z4395D14A(table) {
    return table._obj.getCanSomeRowsExpand();
}

export function Table_getIsSomeRowsExpanded_Z4395D14A(table) {
    return table._obj.getIsSomeRowsExpanded();
}

export function Table_getToggleAllRowsExpandedHandler_Z4395D14A(table) {
    return table._obj.getToggleAllRowsExpandedHandler();
}

export function Table_getIsAllRowsExpanded_Z4395D14A(table) {
    return table._obj.getIsAllRowsExpanded();
}

export function Table_getExpandedDepth_Z4395D14A(table) {
    return table._obj.getExpandedDepth();
}

export function Table_getExpandedRowModel_Z4395D14A(table) {
    return table._obj.getExpandedRowModel();
}

export function Table_getPreExpandedRowModel_Z4395D14A(table) {
    return table._obj.getPreExpandedRowModel();
}

export class Row {
    constructor() {
    }
}

export function Row$reflection() {
    return class_type("Feliz.TanStack.Table.Expanding.Row", void 0, Row);
}

export function Row_getCanExpand_773C3262(row) {
    return row.getCanExpand();
}

export function Row_getIsExpanded_773C3262(row) {
    return row.getIsExpanded();
}

export function Row_toggleExpanded_773C3262(row) {
    if (Row_getCanExpand_773C3262(row)) {
        row.toggleExpanded();
    }
}

//# sourceMappingURL=Expanding.fs.js.map
